export enum Action {
  INIT = 0,
  INIT_VFORM,
  GET_FORM_DEF,
  BUILD_FORMGROUP,
  ALTERFORM_CHANGED,
  ALTERFORM_FETCHING,
  FORM_SUBMIT,
  UPDATE_FIELD,
  CLEAR_ALL,
  SERIALIZE_FIELD,
  SERIALIZE_SECTION,
  SERIALIZE_FORMDATA,
  POST_FORMSUBMIT,
  ERROR_HANDLING,
  DEFAULT,
  FORM_READY,
}
